import { cdnTemplate } from 'cdnPreprocessor';

export default [
  '$location', '$window',
  function PinterestShare ($location, $window) {
    return {
      restrict: 'C',
      replace: true,
      scope: {
        image: '=?',
        description: '=?'
      },
      templateUrl: cdnTemplate('/social-share-button.html'),
      link: (scope) => {
        scope.share = function PinterestShareCall () {
          let uri = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent($location.absUrl())}`;

          if (scope.image) uri += `&media=${encodeURIComponent(scope.image)}`;
          if (scope.description) uri += `&description=${encodeURIComponent(scope.description)}`;

          $window.open(uri);
        };
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/social-share/pinterest.dir.js